// "More views" under the 3D configurator (snippets/ajm-config-photos.liquid, 2026-10-21). The theme's
// zoom view opens at half the photo's full size or the screen fit, whichever is larger
// (product.gallery.photoswipe.js: initialZoomLevel 0.5 with scaleMode 'zoom'), which on a phone
// is about 2.5x the screen. These thumbnails open at the screen fit instead (owner: "they all zoom
// to like 150% on tap"); a double tap or pinch still zooms to full size.
import Photoswipe from 'product.gallery.photoswipe'

class FitPhotoswipe extends Photoswipe {
  getImageData() {
    return super.getImageData().map((item) => Object.assign(item, { initialZoomLevel: 0.01 }))
  }
}

class AjmConfigGallery extends HTMLElement {
  connectedCallback() {
    if (!this.photoswipe) this.photoswipe = new FitPhotoswipe(this, 'ajm-config')
  }
}

if (!customElements.get('ajm-config-gallery')) customElements.define('ajm-config-gallery', AjmConfigGallery)
